import React from 'react';
import { Grid, Typography } from 'antd';
import { ArticleData } from 'models';
import { Link } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

interface ArticleCardProps {
  article: ArticleData;
}

const ArticleCard: React.FC<ArticleCardProps> = ({ article }) => {
  const screens = Grid.useBreakpoint();
  const titleSize = React.useMemo(() => {
    if (screens.xs) {
      return `20px`;
    }
    if (screens.sm) {
      return `25px`;
    }
    return ``;
  }, [screens]);
  const metaBlockWidth = React.useMemo(() => {
    if (screens.xs) {
      return `80%`;
    }
    return `75%`;
  }, [screens]);

  return (
    <div style={{ maxWidth: `100%` }}>
      <Link to={`/blog/${article.slug}`}>
        <div style={{ position: `relative` }}>
          <div
            style={{
              width: `100%`,
              position: `relative`,
              height: `450px`,
              objectFit: `fill`,
              marginBottom: `10px`,
              overflow: `hidden`,
            }}
          >
            <GatsbyImage
              style={{ height: `100%` }}
              className="article-in-list-cover"
              image={getImage(article.image.localFile)}
              alt={
                article.image.alternativeText ||
                `Cover of ${article.title} article`
              }
            />
          </div>
          <div
            style={{
              background: `white`,
              padding: `10px`,
              width: metaBlockWidth,
              position: `absolute`,
              left: 0,
              bottom: 0,
            }}
          >
            <Typography.Paragraph
              type="secondary"
              italic
              style={{ margin: `0` }}
            >
              {article.published_at}
            </Typography.Paragraph>
            <Typography.Title
              level={2}
              style={{ margin: `12px 0`, fontSize: titleSize }}
            >
              {article.title}
            </Typography.Title>
            <Typography.Paragraph type="secondary">
              {article.description}
            </Typography.Paragraph>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default ArticleCard;
